/**
 * Created by sebastienbeaujard on 26/04/2014.
 * Transaction server manager + retry feature
 */
angular.module('FlexyBeautyApp.services').
    factory('GlobalVariable',["$log","AppData", function ($log,AppData)
    {
        var  globalVariable = {
            vat : 20,  //TVA used by application (can be overrided)
            defaultVat: 20
        };

        globalVariable.loadVat = function(  ) {

            var posApp = AppData.getAppByCode("pos");
            if(posApp != null)
            {
                var vatAttr = posApp.getAppAttribute("vat");
                if (vatAttr && vatAttr.value )
                    globalVariable.vat = parseFloat(vatAttr.value);
                else
                    globalVariable.vat = globalVariable.defaultVat;
            }
            else
            {
                globalVariable.vat = globalVariable.defaultVat;
            }
        }
        return   globalVariable;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/tools/GlobalVariable.js